import { useComputedColorScheme } from "@mantine/core";
import logoDark from "@/assets/logos/belora-horizontal-two-color-dark.svg";
import logoLight from "@/assets/logos/belora-horizontal-two-color-light.svg";
import symbolDark from "@/assets/logos/belora-symbol-dark.svg";
import symbolLight from "@/assets/logos/belora-symbol-light.svg";
import { useAppTheme } from "../context/AppTheme";

interface BrandLogoProps {
  variant?: "horizontal" | "symbol";
  height?: number;
  "data-testid"?: string;
}

export function BrandLogo({
  variant = "horizontal",
  height = 32,
  "data-testid": testId,
}: BrandLogoProps) {
  const { themeName } = useAppTheme();
  const colorScheme = useComputedColorScheme("light", {
    getInitialValueInEffect: true,
  });

  if (themeName !== "belora") return null;

  const isDark = colorScheme === "dark";

  if (variant === "symbol") {
    return (
      <img
        src={isDark ? symbolLight : symbolDark}
        alt="Belora"
        height={height}
        style={{ display: "block" }}
        data-testid={testId}
        data-vrt-hide
      />
    );
  }

  return (
    <img
      src={isDark ? logoLight : logoDark}
      alt="Belora"
      height={height}
      style={{ display: "block" }}
      data-testid={testId}
      data-vrt-hide
    />
  );
}
